import './initialize-location-observer.helper';
export function pageview(listener) {
    listener();
    window.addEventListener('locationchange', listener);
    return {
        cleanup: function () {
            window.removeEventListener('locationchange', listener);
        },
    };
}
